// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"3efdf610","258":"5b57db5f"}[chunkId] + ".chunk.css";
};